import { useState, useEffect } from "react";

/**
 * useAuth Hook
 * Centralizes access to localStorage("userLoggedIn")
 */
const useAuth = () => {
    const [user, setUser] = useState(null);

    // Helper to safely parse user data
    const getUserFromStorage = () => {
        try {
            const storedData = localStorage.getItem("userLoggedIn");
            return storedData ? JSON.parse(storedData) : null;
        } catch (error) {
            console.error("Error parsing user data from localStorage:", error);
            return null;
        }
    };

    // We use a simple read on every call to mimic existing behavior of components
    // reading directly from localStorage during render.
    // Using state/effect might cause flickering if we don't initialize synchronously,
    // but standard hooks usually initialize state.
    // HOWEVER, many existing components do `const user = JSON.parse(...)` at the top level.
    // If we change this to `useEffect`, we might break things that expect data immediately.
    // So we will initialize state directly from storage.

    const currentUser = getUserFromStorage();

    return {
        user: currentUser,
        token: currentUser?.token,
        userId: currentUser?.user_id,
        role: currentUser?.role_id,
        supplierId: currentUser?.supplierId, // Some components usage
        isAuthenticated: !!currentUser,
    };
};

export default useAuth;
